import { ChakraProvider, Flex, Box } from "@chakra-ui/react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";
import Sidebar from "./components/Sidebar";
import DashboardContent from "./components/DashboardContent";
import Cameras from "./components/Cameras";
import Machines from "./components/Machines";
import Faces from "./components/Faces";
import Login from "./components/Login";
import Users from "./components/Users";
import PrivateRoute from "./components/PrivateRoute";
import AdminOnlyRoute from "./components/AdminOnlyRoute";
import Algorithms from "./components/Algorithms";
import VehiclePassages from "./components/VehiclePassages";
import TrafficMap from "./components/TrafficMap";
import Fiscalization from "./components/Fiscalization";
// Importar o novo componente modularizado
import InfractionsMain from "./components/infractions/InfractionsMain";
import Batches from "./components/Batches";
import Settings from "./components/Settings";
import SessionExpiredModal from "./components/SessionExpiredModal";

const AppLayout = ({ onLogout, children }) => (
  <Flex>
    <Sidebar onLogout={onLogout} />
    <Box ml={{ base: "0", md: "250px" }} pt={{ base: "64px", md: "0" }} flex="1" minH="100vh" w="100%" maxW="100%" overflowX="hidden">
      {children}
    </Box>
  </Flex>
);

function App() {
  const [sessionExpired, setSessionExpired] = useState(false);

  useEffect(() => {
    const handleAuthExpired = () => setSessionExpired(true);
    window.addEventListener('auth:expired', handleAuthExpired);
    return () => window.removeEventListener('auth:expired', handleAuthExpired);
  }, []);

  const handleLogin = (token) => {
    localStorage.setItem('token', token);
    window.location.href = '/dashboard';
  };

  const handleLogout = async () => {
    const token = localStorage.getItem('token');

    try {
      if (token) {
        await fetch('/api/auth/logout', {
          method: 'POST',
          headers: { Authorization: `Bearer ${token}` }
        });
      }
    } catch (error) {
      console.error('Erro ao registrar logout:', error);
    } finally {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
  };

  return (
    <ChakraProvider>
      <SessionExpiredModal isOpen={sessionExpired} />
      <Router>
        <Routes>
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="/dashboard" element={<PrivateRoute element={() => (
            <AppLayout onLogout={handleLogout}>
              <DashboardContent />
            </AppLayout>
          )} />} />
          <Route path="/machines" element={<PrivateRoute element={() => (
            <AppLayout onLogout={handleLogout}>
              <Machines />
            </AppLayout>
          )} />} />
          <Route path="/cameras" element={<PrivateRoute element={() => (
            <AppLayout onLogout={handleLogout}>
              <Cameras />
            </AppLayout>
          )} />} />
          <Route path="/faces" element={<PrivateRoute element={() => (
            <AppLayout onLogout={handleLogout}>
              <Faces />
            </AppLayout>
          )} />} />
          <Route path="/users" element={<PrivateRoute element={() => (
            <AppLayout onLogout={handleLogout}>
              <Users />
            </AppLayout>
          )} />} />
          <Route path="/algorithms" element={<PrivateRoute element={() => (
            <AppLayout onLogout={handleLogout}>
              <Algorithms />
            </AppLayout>
          )} />} />
          <Route path="/passages" element={<PrivateRoute element={() => (
            <AppLayout onLogout={handleLogout}>
              <VehiclePassages />
            </AppLayout>
          )} />} />
          <Route path="/map" element={<AdminOnlyRoute element={() => (
            <AppLayout onLogout={handleLogout}>
              <TrafficMap />
            </AppLayout>
          )} />} />
          <Route path="/fiscalization" element={<AdminOnlyRoute element={() => (
            <AppLayout onLogout={handleLogout}>
              <Fiscalization />
            </AppLayout>
          )} />} />
          {/* Atualizar a rota de infrações para usar o novo componente */}
          <Route path="/infractions" element={<PrivateRoute element={() => (
            <AppLayout onLogout={handleLogout}>
              <InfractionsMain />
            </AppLayout>
          )} />} />
          <Route path="/batches" element={<PrivateRoute element={() => (
            <AppLayout onLogout={handleLogout}>
              <Batches />
            </AppLayout>
          )} />} />
          <Route path="/settings" element={<PrivateRoute element={() => (
            <AppLayout onLogout={handleLogout}>
              <Settings />
            </AppLayout>
          )} />} />
          <Route path="/access-logs" element={<Navigate to="/users" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </Router>
    </ChakraProvider>
  );
}

export default App;